/* eslint-disable */
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { unregister } from "./registerServiceWorker";
const baseUrl = document.getElementsByTagName("base")[0]?.getAttribute("href");
console.log(baseUrl);
const rootElement = document.getElementById("root");
ReactDOM.render(
  <React.StrictMode basename={baseUrl}>
    <App />
  </React.StrictMode>,
  rootElement
);
unregister();
//registerServiceWorker();
